import {Component, ChangeDetectionStrategy} from '@angular/core';
import {Dialog} from '../../../../../interfaces/dialog/dialog';
import {DialogParams} from '../../../../../interfaces/dialog/dialog-params';
import {FormControl, FormGroup, ReactiveFormsModule, Validators} from '@angular/forms';
import {Partner} from '../../../../../models/partner/partner';

import {Product} from '../../../../../models/product';
import {TrackingDomain} from '../../../../../models/tracking-domain';
import {TrackingDomainService} from '../../../../../services/tracking-domain/tracking-domain.service';
import {DialogService} from '../../../../../services/dialog/dialog.service';
import {SnackbarService} from '../../../../../services/snackbar/snackbar.service';
import {LoaderService} from '../../../../../services/loader/loader.service';

@Component({
  selector: 'app-tracking-domain-form',
  imports: [
    ReactiveFormsModule
],
  templateUrl: './tracking-domain-form.component.html',
  changeDetection: ChangeDetectionStrategy.Eager,
  styleUrl: './tracking-domain-form.component.scss'
})
export class TrackingDomainFormComponent implements Dialog {

  partner: Partner | null = null;
  products: Product[] = [];
  trackingDomain: TrackingDomain | null = null;

  constructor(
    private trackingDomainService: TrackingDomainService,
    private dialog: DialogService,
    private snackbar: SnackbarService,
    private loader: LoaderService
  ) {
  }

  form = new FormGroup({
    domain: new FormControl('', Validators.required),
    productId: new FormControl(),
    partnerId: new FormControl(),
  });

  onDialogInit(params: DialogParams): void {
    this.partner = params.data.partner;
    this.products = params.data.products;
    this.trackingDomain = params.data.trackingDomain;

    this.form.patchValue({
      domain: this.trackingDomain?.domain,
      productId: this.trackingDomain?.productId ?? null,
      partnerId: this.trackingDomain?.partnerId ?? null,
    });
  }

  onSubmit(): void {
    if (this.form.invalid) {
      return;
    }

    this.loader.startLoading();

    if (this.isCreate()) {
      this.trackingDomainService.create(this.form.value).subscribe((data) => {
        this.loader.stopLoading();
        this.snackbar.success('Tracking domain has been created.');
        this.dialog.closeDialog(data);
      });
    } else {
      if (this.trackingDomain?.id) {
        this.trackingDomainService.update(this.trackingDomain.id, this.form.value).subscribe(() => {
          this.loader.stopLoading();
          this.snackbar.success('Tracking domain has been updated.');
          this.dialog.closeDialog();
        });
      }
    }
  }

  isCreate(): boolean {
    return !this.trackingDomain;
  }
}
